import PropTypes from 'prop-types';

export const permissionPropType = PropTypes.shape({
  permissions: PropTypes.array,
  licenses: PropTypes.array,
  roles: PropTypes.array,
  rules: PropTypes.array,
  check: PropTypes.func,
  PERMISSIONS_CONSTANTS: PropTypes.array,
});

export const badgePropType = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.shape({ body: PropTypes.string }),
]);

export const widgetPropType = PropTypes.shape({
  popoverBody: PropTypes.func,
  isActive: PropTypes.func,
  onClickHandler: PropTypes.func,
  iconBody: PropTypes.func,
  badge: badgePropType,
  link: PropTypes.string,
  linkProps: PropTypes.object,
});

export const widgetsPropType = PropTypes.shape({
  admin: widgetPropType,
  calendar: widgetPropType,
  chat: widgetPropType,
  notification: widgetPropType,
  voice: widgetPropType,
  support: widgetPropType,
});

export const userDropdownItemPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
});

export const logoConfigPropType = PropTypes.shape({
  href: PropTypes.string,
  onClick: PropTypes.func,
});

export const userConfigPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(userDropdownItemPropType),
});

export const globalNavigationEnabledPropType = PropTypes.bool;
